export interface IModuleDefinition {
  id: string;
  name: string;
  iframeSrc: string;
  minEntryLimit: number;
  timeoutSeconds: number;
  requiresNotebookEntry?: boolean;
  requiresAcknowledgement?: boolean;
}

export const DEFAULT_MODULE_TIMEOUT_SECONDS = 300;

export interface IModulesCourseDefinition {
  id: number;
  name: string;
  description: string;
  img: string;
  imageAlt: string;
  modules: IModuleDefinition[];
}

export const COURSE_MODULES_LIST: IModulesCourseDefinition[] = [
  {
    id: 1,
    name: 'Course 1: LGBTQ+ 101 and Intersectional Identities',
    description:
      'This course will enable certificated educators to become competent in understanding the intersectional identities related to LGBTQ+ youth in order to effectively support students so they can thrive in school and work towards a more just society.',
    img: 'assets/courses/Course 1.jpg',
    imageAlt:
      'A collage of colorful portrait photos showing many different people in varied poses and lighting.',
    modules: [
      {
        id: 'Intro',
        name: 'Introduction',
        iframeSrc: 'assets/courses/Module1Intro/index.html',
        minEntryLimit: 300,
        // No minimum-stay timer, notebook entry, or acknowledgement required for the Introduction.
        timeoutSeconds: 0,
        requiresNotebookEntry: false,
        requiresAcknowledgement: false
      },
      {
        id: 'A',
        name: 'Module A',
        iframeSrc: 'assets/courses/Module1A/index.html',
        minEntryLimit: 300,
        timeoutSeconds: DEFAULT_MODULE_TIMEOUT_SECONDS
      },
      {
        id: 'B',
        name: 'Module B',
        iframeSrc: 'assets/courses/Module1B/index.html',
        minEntryLimit: 300,
        timeoutSeconds: DEFAULT_MODULE_TIMEOUT_SECONDS
      },
      {
        id: 'C',
        name: 'Module C',
        iframeSrc: 'assets/courses/Module1C/index.html',
        minEntryLimit: 50,
        timeoutSeconds: DEFAULT_MODULE_TIMEOUT_SECONDS
      },
      {
        id: 'D',
        name: 'Module D',
        iframeSrc: 'assets/courses/Module1D/index.html',
        minEntryLimit: 300,
        timeoutSeconds: DEFAULT_MODULE_TIMEOUT_SECONDS
      }
    ]
  }
];

export function getModulesCourseById(id: number): IModulesCourseDefinition | undefined {
  return COURSE_MODULES_LIST.find(c => c.id === id);
}

export function getModuleByIds(courseId: number, moduleId: string): IModuleDefinition | undefined {
  return getModulesCourseById(courseId)?.modules.find(m => m.id === moduleId);
}
